import { differenceInDays, formatISO, isAfter, parseISO } from 'date-fns';
import StoreBuilder from '../store-builder';
import changelog from '@/assets/changelog.md';
import { marked } from 'marked';

class Nouveaute {
  // eslint-disable-next-line no-useless-constructor
  constructor (
    public date: Date,
    public title: string,
    public text: string,
    public link: { text: string, url: string },
    public isNew: boolean
  ) { }
}

const list: Nouveaute[] = [];
(changelog as string).replace(/(\r\n|\n\r)/g, '\n').split(/\n{2,}/).map(news => {
  const match = news.match(/^(?<date>\d{4}-\d\d-\d\d)\n#\s*(?<title>.+)\n(?<text>(?:.|\n)*?)(?:\n(?<link>\[.+?\]\(.+?\)))?$/);

  if (match) {
    const date = parseISO(match.groups.date);
    const link = match.groups.link ? match.groups.link.match(/\[(?<text>.+?)\]\((?<url>.+?)\)/) : null;

    list.push(new Nouveaute(
      date,
      match.groups.title,
      marked(match.groups.text),
      link ? { text: link.groups.text, url: link.groups.url } : null,
      differenceInDays(Date.now(), date) <= 14
    ));
  }
});

const builder = new StoreBuilder('nouveautes');
builder.addStatePart('derniereConsultation', null, null, 'LOCAL');
builder.setGetters({
  list: () => list,
  hasNew: () => list.some(news => news.isNew),
  alerte: (state: any) => list.filter(news => news.isNew && (state.derniereConsultation === null || isAfter(news.date, parseISO(state.derniereConsultation)))).length
});
builder.setActions({
  clearAlerte: ({ dispatch }: any) => {
    dispatch('setDerniereConsultation', formatISO(Date.now()));
  }
});
export default builder.build();
